import React from "react";
import { useLocation } from "react-router-dom";
import logo from "../../Assets/Images/logo.png";

import "@ingka/focus/style.scss";
import "@ingka/hyperlink/style.scss";

import Hyperlink from "@ingka/hyperlink";

export default function Navbar() {
  const location = useLocation();
  const menuitems = [
    { title: "Devices", url: "/" },
    // { title: "Customer Support", url: "#" },
    { title: "Contact Us", url: "/contact" },
  ];

  const [clicked, setClicked] = React.useState(false);
  const navRef = React.useRef(null);
  const toggleButtonRef = React.useRef(null);

  const setClickState = () => {
    setClicked(!clicked);
  };

  // Focus trap and keyboard navigation
  React.useEffect(() => {
    if (!clicked) return;

    const handleKeyDown = (e) => {
      // Close menu on Escape key
      if (e.key === "Escape") {
        setClicked(false);
        toggleButtonRef.current?.focus();
        return;
      }

      // Focus trap - keep focus within menu when open
      if (e.key === "Tab" && navRef.current) {
        const focusableElements = navRef.current.querySelectorAll(
          'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])',
        );
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey && document.activeElement === firstElement) {
          // Shift+Tab on first element - go to last
          e.preventDefault();
          lastElement?.focus();
        } else if (!e.shiftKey && document.activeElement === lastElement) {
          // Tab on last element - go to first
          e.preventDefault();
          firstElement?.focus();
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [clicked]);

  // Prevent body scroll when menu is open
  React.useEffect(() => {
    if (clicked) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [clicked]);

  return (
    <div className="container">
      <header className="header">
        <div className="logo">
          <a href="/">
            <img src={logo} alt="IKEA Logo" />
          </a>
        </div>
        <nav aria-label="Main navigation" ref={navRef}>
          <button
            ref={toggleButtonRef}
            className="nav-toggle"
            onClick={setClickState}
            aria-expanded={clicked}
            aria-label="Toggle navigation menu"
          >
            <i className={clicked ? "fas fa-times" : "fas fa-bars"}></i>
          </button>
          <ul className={clicked ? "nav-menu active" : "nav-menu"}>
            {menuitems.map((item, index) => {
              const isActive = location.pathname === item.url;
              return (
                <li key={index}>
                  <Hyperlink
                    className="link--subtle .link--grey"
                    url={item.url}
                    text={item.title}
                    aria-current={isActive ? "page" : undefined}
                    onClick={() => setClicked(false)}
                  />
                </li>
              );
            })}
          </ul>
        </nav>
      </header>
    </div>
  );
}
